import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import { appStrings } from "../common/strings/app_strings"
import OnboardingSection from "../components/onboarding/onboarding_section"
import { SettingsFormField } from "../components/settings/settings_form_field"
import ToggleAddAnother from "../components/onboarding/toggle_add_another"
import { guid } from "../util/random_utils"
import {
    updateBaseMapField,
    makeTagField,
    parseTagsToTextArea,
    parseTextAreaToTags,
} from "../util/onboarding_utils"

const {
    sectionTitle,
    buttonText,
    sectionDetail,
    fieldPlaceholder,
    textAreaPlaceholder,
    addOneByOne,
} = appStrings.addProject

const initialState = {
    tags: { 1: makeTagField("1", "") },
}

class AddProjects extends React.Component {
    constructor(props) {
        super(props)

        this.state = initialState
        this.textInput = null
        this.setTextInputRef = element => (this.textInput = element)
        this.focusTextInput = () => {
            if (this.textInput) this.textInput.focus()
        }
    }

    handleNavigate = e => {
        const { tags } = this.state
        // check if the user has clicked "Skip for later"
        const patchMeta = e.target.id === "skip" ? {} : tags
        this.props.handleNavigateAndPatch(patchMeta, this.props.history)
    }

    addRow = () => {
        const id = guid()
        const tags = {
            ...this.state.tags,
            [id]: makeTagField(id),
        }
        this.setState({ tags })
        // focus new field
        this.delayedFocus()
    }

    delayedFocus = () => {
        setTimeout(() => {
            this.focusTextInput()
        }, 200)
    }

    removeRow = id => {
        const tags = { ...this.state.tags }
        delete tags[id]

        this.setState({ tags })
    }

    toggleIsTextArea = () => {
        const { tags, isTextArea, textAreaContent } = this.state
        this.setState({ isTextArea: !isTextArea })
        if (!isTextArea) {
            const tagNames = parseTagsToTextArea(tags)
            this.setState({ textAreaContent: tagNames }, () => {
                this.delayedFocus()
            })
            return
        }
        const newTags = parseTextAreaToTags(textAreaContent)
        this.setState({ tags: newTags }, () => {
            this.delayedFocus()
        })
    }

    handleTagFieldChange = (value, id) => {
        const tags = updateBaseMapField(this.state.tags, value, id, "name")
        this.setState({ tags })
    }

    renderRows = () => (
        <div className="row">
            <div className="col-md-12">
                {Object.keys(this.state.tags).map((id, i) => {
                    const tag = this.state.tags[id]
                    return (
                        <div className="form-group tag-item-wrapper" key={id}>
                            <SettingsFormField
                                focus={i === 0 && !this.textInput}
                                value={tag.name}
                                id={id}
                                placeholder={fieldPlaceholder}
                                required={false}
                                className="form-group"
                                onChangeAction={this.handleTagFieldChange}
                                setRef={this.setTextInputRef}
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )

    renderTextArea = () => {
        const { textAreaContent } = this.state
        return (
            <div className="row">
                <div className="col-md-12 form-group">
                    <textarea
                        ref={this.setTextInputRef}
                        value={textAreaContent}
                        placeholder={textAreaPlaceholder}
                        className="form-control"
                        onChange={e => {
                            this.handleTextAreaChange(e.target.value)
                        }}
                    />
                </div>
            </div>
        )
    }

    renderTextAreaOrRows = () =>
        this.state.isTextArea ? this.renderTextArea() : this.renderRows()

    handleTextAreaChange = textAreaContent => {
        const newTags = parseTextAreaToTags(textAreaContent)
        this.setState({
            textAreaContent,
            tags: newTags,
        })
    }

    render() {
        const { isTextArea } = this.state
        return (
            <OnboardingSection
                sectionTitle={sectionTitle}
                buttonValue={buttonText}
                onClickAction={this.handleNavigate}
                hasSkipButton={true}
                isWide={false}
                extraBottomPadding={true}
            >
                <div className="col-md-12 form-group">
                    <p className="tag-description">{sectionDetail}</p>
                </div>
                {this.renderTextAreaOrRows()}
                <div className="row">
                    <ToggleAddAnother
                        addRow={this.addRow}
                        toggleIsTextArea={this.toggleIsTextArea}
                        isTextArea={isTextArea}
                        addOneByOne={addOneByOne}
                    />
                </div>
            </OnboardingSection>
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(AddProjects)



// WEBPACK FOOTER //
// ./src/pages/add_projects.jsx